module.exports = __webpack_public_path__ + "static/media/list.8220d92e.svg";